import i18n from 'i18next';
import Backend from "i18next-http-backend";
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getDisplayLangCode } from '../Internationalization/handleAppInternationalization';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
      // UI language: browser language on web sign-up, query-string/domain language when a `language` query parameter exists.
      // Data language (payloads, persistence, B2C) is NOT derived from this value.
      lng: getDisplayLangCode(),
      load: "currentOnly",
      debug: false,
      fallbackLng: 'en-GB',
      ns: ['translation'],
      defaultNS: ['translation'],
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      react: {
          useSuspense: true
      }
  });

export default i18n;
